<ng-container *transloco="let t; prefix: 'shared.attachment'">
<div class="modal-header">
  <h5 class="modal-title">{{ t('title') }}</h5>
  <button type="button" class="close-btn" (click)="close()">
    <img src="assets/icons/close-icon.svg" [alt]="'common.close' | transloco" />
  </button>
</div>

<div class="modal-body">
  @if (isLoading) {
    <div class="loading-state">
      <span class="spinner-border text-secondary"></span>
    </div>
  } @else if (fileUrl && isImage) {
    <div
      class="attachment-preview"
      (wheel)="onWheel($event)"
      (mousedown)="onMouseDown($event)"
      (dblclick)="resetZoom()"
      [class.dragging]="isDragging"
      [class.zoomable]="scale > 1"
    >
      <img
        [src]="fileUrl"
        [alt]="t('title')"
        class="slip-image"
        [style.transform]="imageTransform"
        draggable="false"
      />
      @if (scale === 1) {
        <div class="zoom-hint">
          <i class="bi bi-zoom-in"></i> {{ t('scrollToZoom') }}
        </div>
      } @else {
        <div class="zoom-controls">
          <button class="zoom-reset-btn" (click)="resetZoom()">
            <i class="bi bi-arrow-counterclockwise"></i> {{ t('resetZoom') }}
          </button>
        </div>
      }
    </div>
  } @else if (fileUrl && isPdf) {
    <div class="pdf-preview">
      <iframe [src]="safeFileUrl" class="pdf-frame" [title]="t('documentPreview')"></iframe>
    </div>
  } @else if (fileUrl && !isImage) {
    <div class="no-attachment-wrapper">
      <div class="no-attachment-box">
        <img src="assets/icons/Info Icon.svg" [alt]="t('noPreview')" class="no-attachment-icon" />
        <p class="no-attachment-title">{{ t('noPreview') }}</p>
        <p class="no-attachment-subtitle">{{ t('downloadToView') }}</p>
      </div>
    </div>
  } @else {
    <div class="no-attachment-wrapper">
      <div class="no-attachment-box">
        <img src="assets/icons/Info Icon.svg" [alt]="t('noAttachment')" class="no-attachment-icon" />
        <p class="no-attachment-title">{{ t('noAttachment') }}</p>
        <p class="no-attachment-subtitle">{{ t('noAttachmentYet') }}</p>
      </div>
    </div>
  }
</div>

<div class="modal-footer">
  <button class="btn-cancel" (click)="close()">{{ 'common.close' | transloco }}</button>
  <button class="download-btn" [disabled]="!downloadUrl && !fileUrl" (click)="download()">{{ 'common.download' | transloco }}</button>
</div>
</ng-container>
